import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../css/nav.css';
import chestInactive from './chestInactive.png';
import chestActive   from './chestActive.png';
import homeActive from './homeActive.png';
import homeInactive from './homeInactive.png';
import storyActive from './storyActive.png';
import storyInactive from './storyInactive.png';
import mediaActive from './mediaActive.png';
import mediaInactive from './mediaInactive.png';

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeIcon, setActiveIcon] = useState(null);

  const toggleMenu = () => setMenuOpen(v => !v);

  const handleNavClick = (icon) => {
    setActiveIcon(icon);
    setMenuOpen(false);
  };

  return (
    <nav className="nav">
      <div className="nav-container">
        <button className="main-icon" onClick={toggleMenu}>
          <img
            src={menuOpen ? chestActive : chestInactive}
            alt="Main menu"
          />
        </button>

        <div className={`nav-icons-container ${menuOpen ? 'open' : ''}`}>
          <Link to="/story" className="nav-icon story-icon" onClick={() => handleNavClick('story')}>
            <img src={activeIcon === 'story' ? storyActive : storyInactive} alt="Story" />
          </Link>

          <Link to="/media" className="nav-icon media-icon" onClick={() => handleNavClick('media')}>
            <img src={activeIcon === 'media' ? mediaActive : mediaInactive} alt="Media" />
          </Link>

          <Link to="/" className="nav-icon home-icon" onClick={() => handleNavClick('home')}>
            <img src={activeIcon === 'home' ? homeActive : homeInactive} alt="Home" />
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
